(function($) {

  var $someImages = $('.u-OF-cover');
  objectFitImages($someImages);

})(jQuery);